module.exports = __webpack_public_path__ + "img/Frame4454.6ea6831a.png";